import { Box, Grid } from '@mui/material';
import ToolsAndTechnologiesCard from './tools-and-technology-card';
import { IPermissions, TabInfo } from '../../common/utils/interfaces';
import { Tool } from '../type';
import NoRecords from '../../common/application/no-records';

interface PropsType {
  toolsAndTechnologies: Tool[];
  editToolCallback: (toolId: string) => void;
  tabs: TabInfo[];
  permissions: IPermissions | undefined;
}

const ToolsAndTechnologiesGrid = ({
  editToolCallback,
  toolsAndTechnologies,
  tabs,
  permissions
}: PropsType): JSX.Element => {
  return (
    <>
      {toolsAndTechnologies.length !== 0 ? (
        <Grid container spacing={4}>
          {toolsAndTechnologies.map((toolAndTechnology) => (
            <Grid
              key={toolAndTechnology.id}
              item
              xs={12}
              sm={12}
              md={6}
              lg={4}
              xl={3}
            >
              <ToolsAndTechnologiesCard
                tool={toolAndTechnology}
                editToolCallback={editToolCallback}
                tabs={tabs}
                permissions={permissions}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
          }}
        >
          <NoRecords message={'No Tools Or Technologies Available'} />
        </Box>
      )}
    </>
  );
};

export default ToolsAndTechnologiesGrid;
